import React from 'react'
import clsx from 'clsx'
import { useInView } from 'react-hook-inview'

import { User } from '../MergeContactBox'

import MediaAvatar from '../../../atoms/MediaAvatar'

import useStyles from './styles'
import PhoneFlag from '../../../atoms/PhoneFlag'
import { getFormatted } from '../../../../utilities/phoneNumber'

type SearchResultProps = {
  user: User
}

const SearchResult: React.FC<SearchResultProps> = ({ user }) => {
  const [inViewRef, inView] = useInView({
    root: document.querySelector('#merge-search-results')
  })

  const classes = useStyles()

  return (
    <div ref={inViewRef} className={classes.root}>
      {inView ? (
        <>
          <div className={classes.avatarArea}>
            <MediaAvatar user={user} hideCard className={classes.avatar} />
          </div>

          <div className={classes.detailsArea}>
            <div className={classes.name}>{user.name}</div>

            {user.channels.map(channel => {
              const isPhone = ['sms_voice', 'voice_only'].includes(channel.type)
              let value = channel.value
              if (isPhone) {
                value = getFormatted(value)
              }

              return (
                <div className={classes.detailRow}>
                  {isPhone && (
                    <PhoneFlag value={channel.value} className='flag' />
                  )}

                  <div
                    className={clsx(
                      classes.detailValue,
                      isPhone && classes.detailPhone
                    )}
                  >
                    {value}
                  </div>
                </div>
              )
            })}
          </div>
        </>
      ) : (
        <>
          <div className={classes.avatarArea}>
            <div className={clsx(classes.avatar, classes.mockAvatar)} />
          </div>

          <div className={classes.mockName} />
        </>
      )}
    </div>
  )
}

export default SearchResult
